import script from "./SplashScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SplashScreen.vue?vue&type=script&setup=true&lang=js"

import "./SplashScreen.vue?vue&type=style&index=0&id=7009abe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7009abe6"]])

export default __exports__